// React
import React from 'react';

// Components
import Wrapper from '../../listing/Wrapper/Wrapper';

// Contexts
import { ListingContext } from '../../../contexts/listing';

// Hooks
import useListing from '../../../hooks/useListing';

// Data types
import {
  packageCore,
  packageListing
} from '../../../data-types/package';

// This component
export default function Package() {
  // Data types
  const { endpoint } = packageCore();
  const {
    initialSort,
    initialFilters,
    getColumns,
    getRows,
    getFilters
  } = packageListing();

  // Listing
  const {
    activeFilters,
    saveActiveFilters,
    page,
    pageSize,
    setPage,
    setPageSize,
    sortModel,
    setSortModel,
    resetSortModel,
    refreshDataGrid,
    setRefreshDataGrid
  } = useListing(initialSort, initialFilters, endpoint);

  // JSX
  return (
    <ListingContext.Provider
      value={{
        typeOfData: 'data-type',
        // Static
        initialFilters,
        endpoint,
        getColumns,
        getRows,
        getFilters,
        // Dynamic
        activeFilters,
        saveActiveFilters,
        page,
        pageSize,
        setPage,
        setPageSize,
        sortModel,
        setSortModel,
        resetSortModel,
        refreshDataGrid,
        setRefreshDataGrid
      }}>
      <Wrapper
        title="Packages"
        buttonNewLabel="New Package"
        buttonNewUrl="/package/new"
        exportAction={true}
        buttonExportLabel="Export Data"
      />
    </ListingContext.Provider>
  );
}
